import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Dialog, IconButton, Link, Box, Typography } from '@material-ui/core';
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import Alert from 'sharedComponents/Alert';

import useApp from 'reducers/hooks/useApp';
import { GET_ENUMS } from 'const/router';
import { useTranslation } from 'react-i18next';
import { getServerError, getServerErrorsFullMessages } from 'utils/errors';

import GoogleAuthButton from 'sharedComponents/GoogleAuthButton';

import { appRoutes } from 'routes';
import LoginForm from 'sharedComponents/LoginForm';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';

import useStyles from './useStyles';

const Login = props => {
  const { onClose } = props;
  const { loadCurrentUser, login, loginWithGoogle, isLoggingIn } = useApp();
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isMobile } = useScreen();

  const [alert, setAlert] = useState({ show: false, text: '', severity: '' });
  const handleCloseAlert = () => setAlert({ ...alert, show: false });

  const handleSubmit = async (values, { setErrors }) => {
    try {
      await login(values);
      loadCurrentUser();
      history.push(appRoutes.rootPath());
    } catch (error) {
      const errorMessage = getServerError(error);
      setErrors({ serverError: errorMessage });
    }
  };

  const handleSignInWithGoogle = async response => {
    const { credential } = response;

    try {
      await loginWithGoogle({ tokenId: credential, provider: 'google_oauth2' });
      loadCurrentUser();
      history.push(appRoutes.rootPath());
    } catch (_err) {
      const { fullErrorMessages } = getServerErrorsFullMessages(_err);
      setAlert({ show: true, text: fullErrorMessages, severity: 'error' });
    }
  };

  return (
    <Dialog open onClose={onClose} fullScreen={isMobile}>
      <IconButton className={classes.dialogClose} onClick={onClose}>
        <Icon name="bigClose" />
      </IconButton>
      <Box width="100%" display="flex" justifyContent="center">
        <Typography variant="h1">{t('components.Login.header')}</Typography>
      </Box>
      <div className={classes.socialBox}>
        <GoogleAuthButton onSuccess={handleSignInWithGoogle} />
      </div>
      <div className={classes.divider}>
        <div className={classes.line} />
        <Typography variant="body1">{t('components.Login.or')}</Typography>
        <div className={classes.line} />
      </div>
      <LoginForm onSubmit={handleSubmit} isLoggingIn={isLoggingIn} />
      <div className={classes.links}>
        <Link
          component={RouterLink}
          className={classes.link}
          to={{ pathname, search: `?popup=${GET_ENUMS.popup.forgotPassword}` }}
        >
          {t('components.Login.forgotPassword')}
        </Link>
        <Link
          component={RouterLink}
          className={classes.link}
          to={{ pathname, search: `?popup=${GET_ENUMS.popup.signUp}` }}
        >
          {t('components.Login.signUp')}
        </Link>
      </div>
      {alert.show && <Alert text={alert.text} open severity={alert.severity} handleClose={handleCloseAlert} />}
    </Dialog>
  );
};

Login.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js